import { webClient } from "@shared/apis"
import { PaymentInformation, Schedule } from "@shared/contexts"
import { Pagination } from "@shared/types"

export default {
  get: (
    username: string,
    paymentInformation: PaymentInformation,
    isRecorded: boolean = true,
    page: number = 1,
    size: number = 10,
    scheduleStartDate?: string,
    scheduleEndDate?: string
  ) =>
    webClient.get<Pagination<Schedule>>(`/schedules`, {
      params: { username, page, size, paymentInformation, isRecorded, scheduleStartDate, scheduleEndDate },
    }),
  findBy: (scheduleId: number | string) =>
    webClient.get<Schedule>(`/schedules/${scheduleId}`),
  changeStreaming: (scheduleId: number | string, username: string) =>
    webClient.put<Schedule>(`/schedules/${scheduleId}/change_streaming`, {
      managerName: username,
    }),
  blacklistChattingRole: (
    scheduleId: number | string,
    blacklistChattingRole: BlacklistChattingRoleType,
    isEnabled: boolean,
  ) =>
    webClient.put<Schedule>(
      `/schedules/${scheduleId}/blacklist_chatting_role`,
      {
        blacklistChattingRole,
        isEnabled,
      },
    ),
  getRecommends: (page: number = 1, size: number = 4) =>
    webClient.get<Pagination<Schedule>>(`/schedules/recommends`, {
      params: { page, size },
    }),
  blind: (messageKey: string | number | undefined, scheduleId: number) =>
    webClient.put<Schedule>(
      `/schedules/${scheduleId}/messages/${messageKey}/blind`,
    ),
  changeEmoticon: (scheduleId: number | string, isEmoticon: boolean) =>
    webClient.put<Schedule>(`/schedules/${scheduleId}/change_emoticon`, {
      isEmoticon,
    }),
  changeCongratsMessage: (
    scheduleId: number | string,
    isCongratsMessage: boolean,
  ) =>
    webClient.put<Schedule>(
      `/schedules/${scheduleId}/change_congrats_message`,
      {
        isCongratsMessage,
      },
    ),
}

export const ALL_BLACK_LIST_CHATTING_ROLE = [
  "ALL",
  "USER",
  "PAID_USER",
  "FREE_USER",
  "NOT_MATCHED_USER",
  "OTHER_PAID_USER",
] as const
type BlacklistChattingRoleTuple = typeof ALL_BLACK_LIST_CHATTING_ROLE
export type BlacklistChattingRoleType = BlacklistChattingRoleTuple[number]
